import React from 'react';
import { useMoneyFormat } from '../../../context/LocaleContext';
import useNames from '../../../hooks/useNames';
import s from './popover.module.css';

// One attendee and what this lesson costs them. An em dash rather than $0.00
// when there is no price: "no charge" and "free" are different statements.

export default function AttendeeRow({ student, priceMinor }) {
  const formatMoney = useMoneyFormat();
  const names = useNames();
  return (
    <div className={s.attendee}>
      <span className={s.attendeeName}>{names.student(student)}</span>
      <span className={s.attendeePrice}>
        {priceMinor != null ? formatMoney(priceMinor) : '—'}
      </span>
    </div>
  );
}
